<template>
  <v-row>
    <v-btn fab small @click="back">
      <v-icon dark>mdi-arrow-left</v-icon>
      <!-- {{ $t('cart.go_back') }} -->
      </v-btn> 
  </v-row>
</template>

<script>
import { back } from "./utils.js";

export default {
  name: "GoBack",
  data: () => ({}),

  methods: {
    back: function() {
      back();
    }
  }
};
</script>
